function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#09CAC7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.625 20.191c.498 0 .992.028 1.48.082l-.06-2.778a.68.68 0 0 1 .33-.596.691.691 0 0 1 .687-.015l9.048 4.923a.68.68 0 0 1 .357.582.68.68 0 0 1-.331.597l-8.828 5.302a.691.691 0 0 1-.686.015.68.68 0 0 1-.356-.582l-.057-2.617a8.558 8.558 0 0 0-1.584-.149c-4.642 0-8.418 3.742-8.418 8.341 0 4.599 3.776 8.34 8.418 8.34 4.361 0 7.963-3.238 8.379-7.532a2.396 2.396 0 0 1 2.622-2.144 2.388 2.388 0 0 1 2.163 2.599c-.653 6.75-6.312 11.841-13.164 11.841-7.293 0-13.225-5.879-13.225-13.104 0-7.226 5.932-13.105 13.225-13.105z",
  fill: "#fff"
});

function SvgForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.468b0dbe.svg";
export { ForwardRef as ReactComponent };